import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import api, { formatApiError } from "@/api";
import { AuthLayout } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const { t } = useLanguage();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError(t("auth.passwordTooShort"));
      return;
    }
    if (password !== confirm) {
      setError(t("auth.passwordsMismatch"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err, t));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title={t("auth.resetTitle")} testid="reset-password-page">
      {done ? (
        <div className="space-y-6">
          <p className="text-sm text-emerald-700 font-medium" data-testid="reset-success">{t("auth.resetSuccess")}</p>
          <Link to="/entrar" data-testid="reset-to-login" className="block text-center text-sm text-accent font-semibold hover:underline">{t("auth.backToLogin")}</Link>
        </div>
      ) : !token ? (
        <div className="space-y-6">
          <p className="text-sm text-destructive" data-testid="reset-error">{t("auth.resetMissingToken")}</p>
          <Link to="/recuperar-palavra-passe" data-testid="reset-request-new" className="block text-center text-sm text-accent font-semibold hover:underline">{t("auth.forgotTitle")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="reset-password">{t("auth.newPassword")}</Label>
            <PasswordInput id="reset-password" data-testid="reset-password-input" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12 rounded-xl" />
          </div>
          <div>
            <Label htmlFor="reset-confirm">{t("auth.confirmPassword")}</Label>
            <PasswordInput id="reset-confirm" data-testid="reset-confirm-input" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-12 rounded-xl" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
          <Button data-testid="reset-submit-button" type="submit" disabled={loading} className="w-full h-12 rounded-full bg-primary hover:bg-primary/90 text-white font-semibold">{t("auth.resetBtn")}</Button>
        </form>
      )}
    </AuthLayout>
  );
}
